import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import {
  BackButton,
  ViewTitle,
} from '@iarcpsu/emanufac-components/src/components';
import { Button, Card, Checkbox, FormControlLabel } from '@mui/material';
import dayjs from 'dayjs';
import BuddhistCalendar from 'dayjs/plugin/buddhistEra';
import _ from 'lodash';
import PropTypes from 'prop-types';

import * as actions from '@/redux/actions';

import 'dayjs/locale/th';

dayjs.extend(BuddhistCalendar);

const HRMSModuleSetting = ({ title, subtitle }) => {
  const dispatch = useDispatch();
  const information = useSelector((state) => state.information);

  const { control, handleSubmit } = useForm({
    defaultValues: { setting: { hrms: information?.setting?.hrms } },
  });

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  const handleChangeSetting = async (data) => {
    console.log('Data', data);
    const confirm = window.confirm('ยืนยันการปรับการตั้งค่า');
    if (confirm) {
      try {
        await dispatch(
          actions.informationPut(information?._id, {
            setting: {
              ...information.setting,
              hrms: {
                ...data.setting.hrms,
              },
            },
          }),
        );
        await dispatch(actions.informationAll());
        window.alert('แก้ไขการตั้งค่าสำเร็จ');
      } catch (error) {
        window.alert('แก้ไขการตั้งค่าไม่สำเร็จ');
        console.error('แก้ไขการตั้งค่าไม่สำเร็จ', error);
      }
    }
  };

  return (
    <div>
      {renderTitle()}
      <div className="flex flex-row justify-start pb-4">
        <div>
          <BackButton />
        </div>
      </div>
      <form onSubmit={handleSubmit(handleChangeSetting)}>
        <div>
          <Card className="p-4">
            <div className="flex flex-wrap w-full ">
              <div className="w-full py-2 px-2 font-semibold font-display ">
                ตั้งค่าระบบทรัพยากรบุคคล
              </div>
              <div className="w-1/2 py-2 px-2">
                การแสดงผลในระบบทรัพยากรบุคคล
              </div>
              <div className="w-1/2 py-2 px-2">
                <div className="flex flex-col w-full">
                  <Controller
                    control={control}
                    name="setting.hrms.use_display_name"
                    render={({ field }) => (
                      <FormControlLabel
                        {...field}
                        control={<Checkbox defaultChecked={field.value} />}
                        label="ใช้ชื่อแสดงแทน / ชื่อเล่น"
                      />
                    )}
                  />
                  <Controller
                    control={control}
                    name="setting.hrms.use_electronic_signature"
                    render={({ field }) => (
                      <FormControlLabel
                        {...field}
                        control={<Checkbox defaultChecked={field.value} />}
                        label="ใช้ลายเซ็นอิเล็กทรอนิกส์"
                      />
                    )}
                  />
                </div>
              </div>
            </div>
          </Card>
        </div>
        <div className="flex justify-end mt-2">
          <Button color="primary" variant="contained" type="submit">
            บันทึก
          </Button>
        </div>
      </form>
    </div>
  );
};

HRMSModuleSetting.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

HRMSModuleSetting.defaultProps = {
  title: '',
  subtitle: '',
};
export default HRMSModuleSetting;
